import { render, staticRenderFns } from "./LoadInfoEdit.vue?vue&type=template&id=0890eb8b&"
import script from "./LoadInfoEdit.vue?vue&type=script&lang=js&"
export * from "./LoadInfoEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports